const PAINS = [
  {
    pain: "Cerchi un utensile e nessuno sa dove sia finito.",
    cost: "20 minuti a ricerca, due o tre volte al giorno",
  },
  {
    pain: "Compri due volte lo stesso inserto perché la giacenza non è affidabile.",
    cost: "300-600 € al mese di scorte doppie",
  },
  {
    pain: "La macchina si ferma perché l'utensile giusto non c'è.",
    cost: "2 ore a settimana × 70 €/h = 6.400 € l'anno",
  },
  {
    pain: "Non sai quanto costa in utensili e ore il pezzo che stai producendo.",
    cost: "margine deciso a sentimento, commessa dopo commessa",
  },
  {
    pain: "I piani di controllo sono su carta e l'audit è fra due settimane.",
    cost: "3-5 giorni/uomo per ricostruire le prove",
  },
  {
    pain: "Chi sa come si lavora quel pezzo è una persona sola.",
    cost: "l'officina rallenta appena quella persona manca",
  },
];

export function PainPointsSection() {
  return (
    <section className="landing-pains" id="problemi" data-testid="landing-pains">
      <div className="landing-section-head landing-reveal">
        <p className="landing-module-num">TI RICONOSCI? <i /> IL PROBLEMA</p>
        <h2>Sei problemi che in officina costano ogni settimana</h2>
        <p className="landing-desc">
          Sono ore, euro e nervi. Gli importi qui accanto sono quelli tipici di un'officina con 5-15 CNC:
          più avanti trovi il calcolatore per metterci i tuoi numeri.
        </p>
      </div>
      <div className="landing-pain-grid">
        {PAINS.map((item, index) => (
          <article
            className="landing-pain landing-reveal"
            style={{ transitionDelay: `${index * 70}ms` }}
            key={item.pain}
            data-testid={`landing-pain-${index + 1}`}
          >
            <span className="landing-pain-num">{String(index + 1).padStart(2, "0")}</span>
            <p className="landing-pain-text">{item.pain}</p>
            <p className="landing-pain-cost"><b>COSTO</b> {item.cost}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
